var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCorporateSocialMedia = function SvgCorporateSocialMedia(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.000166680556713,0,0,2.000166680556713,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.252,1.956A9,9,0,1,0,11.883,18.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.261,12.75h9.754"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.261,6.75h9.754"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.807.961a29.153,29.153,0,0,0,.68,17.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.69.961A29.109,29.109,0,0,1,12.455,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.249,23.25H1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.249,23.25h9V9.1a.491.491,0,0,0-.5-.472h-8a.49.49,0,0,0-.5.472Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.5,5.868a.691.691,0,0,1,.75-.618h3a.691.691,0,0,1,.75.618v2.76H16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.749,5.25V1.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.249,12.09h-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.249,15.725h-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.249,19.372h-3"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCorporateSocialMedia);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "corporate-social-media.2837da758824ef8a479d33d24cf10360.svg";